import { css } from '@emotion/react'

import type { CarouselItemProps } from './interfaces'

const itemCss = css`
  width: 366px;
`

const itemSnapPointCss = css`
  scroll-snap-align: start;
`

const previewCss = css`
  cursor: zoom-in;
  width: 100%;
`

interface Props extends CarouselItemProps {
  preview?: boolean
  onClick?: () => void
  className?: string
}

export const CarouselItem = ({
  isSnapPoint,
  onClick,
  preview,
  className,
  children,
}: Props) => (
  <li
    css={[itemCss, isSnapPoint && itemSnapPointCss, preview && previewCss]}
    className={className}
    onClick={onClick}
  >
    {children}
  </li>
)
